import { useCallback, useRef } from "react";

const CROP_COLOR_KEYS = ['#396485', '#658245', '#65A77D', '#9DC34F', '#C2E7FE'];

/**
 * Generates a color within a range that should look decent with the predefined colors.
 * @returns HSL Color
 */
function generate() {
  const h = Math.floor(Math.random() * 180);
  const s = Math.floor((Math.random() * 20) + 39);
  const l = Math.floor((Math.random() * 25) + 51);

  return `hsl(${h}, ${s}%, ${l}%)`;
}

export default function useColorPool() {
  const pool = useRef([...CROP_COLOR_KEYS]);

  const retrieve = useCallback(() => {
    // Get the next color from the pool or generate a temporary one.
    return pool.current.shift() ?? generate();
  }, []);

  const release = useCallback((value = "") => {
    // Reuse colors only if they were in the original list.
    if (value.startsWith('#')) {
      pool.current.push(value);
    }
  }, []);

  return { retrieve, release };
}
